import { DEFAULT_MINUTES_FORMAT } from '@constants';
import { useSectorMark } from '@hooks/useSectorMarkHook';
import { numFormat } from '@utils/tool';
import { ColumnsType } from 'antd/es/table';
import BlueStarIcon from '@assets/image/Icons/blue-star.svg';

const maxLength = 200; // input框最大长度
const amountMaxLength = 9; // 数字框最大长度
const amountMax = 999999999; // 数字框最大值

export const subjectMatterErrorText =
  '请填写整包中标金额或整包中标金额备注中一项或多项';

const noticeLinkValidator = (rule: any, value: string) => {
  if (!value) {
    return Promise.resolve();
  }
  if (/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g.test(value.trim())) {
    return Promise.reject('只能输入英文和符号');
  }

  return Promise.resolve();
};

// 新建公告
export const use_NOTICE_FORM_LIST = () => {
  const sectorMark = useSectorMark();
  return [
    {
      label: '公告类型',
      required: true,
      type: 'select',
      name: 'noticeType',
      optionsListKey: 'noticeType'
    },
    {
      label: '信息标题',
      required: false,
      type: 'input',
      name: 'infoTitle'
    },
    {
      label: '项目名称',
      required: true,
      type: 'input',
      name: 'noticeName',
      maxLength
    },
    {
      label: '客户单位',
      required: true,
      type: 'input',
      name: 'customerCompany',
      maxLength
      // showCount: true
    },
    {
      label: '客户单位联系人',
      required: false,
      type: 'input',
      name: 'tenderOrgContacts',
      maxLength
    },
    {
      label: '客户单位联系方式',
      required: false,
      type: 'input',
      name: 'tenderOrgContactsMobile',
      maxLength
    },
    {
      label: sectorMark,
      required: true,
      type: 'select',
      name: 'sectorType',
      optionsListKey: 'sector'
    },
    {
      label: '客户单位类型',
      required: false,
      type: 'cascader',
      name: 'customerCompanyType'
      // optionsListKey: 'sector'
    },
    {
      label: '行业',
      required: false,
      type: 'select',
      name: 'industryKey'
    },
    {
      label: '应用方向',
      required: false,
      type: 'cascader',
      name: 'applicationDirectionKey'
    },
    {
      label: '招标预算（万元）',
      required: false,
      type: 'amount',
      name: 'tenderBudget',
      maxLength: amountMaxLength,
      max: amountMax
    },
    // {
    //   label: '预计采购时间',
    //   required: false,
    //   type: 'time',
    //   name: 'estimatedPurchaseTime'
    // },
    {
      label: '发布时间',
      required: false,
      type: 'time',
      name: 'publishTime',
      format: DEFAULT_MINUTES_FORMAT,
      showTime: true
    },
    {
      label: '开标时间',
      required: false,
      type: 'time',
      name: 'tenderOpenTime'
      // format: DEFAULT_MINUTES_FORMAT,
      // showTime: true
    },
    {
      label: '整包中标金额（万元）',
      required: false,
      type: 'amount',
      disabled: true,
      name: 'successfulPrice',
      maxLength: amountMaxLength,
      max: amountMax
    },
    {
      label: '整包中标金额备注',
      required: false,
      type: 'input',
      name: 'successfulPriceRemark',
      maxLength
    },
    {
      label: '省市',
      required: true,
      type: 'cascader',
      name: 'provinceAndCity'
    },
    {
      label: '招标机构',
      required: false,
      type: 'input',
      name: 'tenderDealer',
      maxLength
    },

    {
      label: '公告链接',
      required: true,
      type: 'input',
      name: 'noticeLink',
      maxLength,
      rules: [
        { required: true },
        { validator: noticeLinkValidator },
        { whitespace: true }
      ]
    }
  ];
};

// 新建公告中的标的物
export const TARGET_STUFF = [
  {
    label: '产品分类',
    required: true,
    type: 'select',
    name: 'productLineKey',
    optionsListKey: 'productLine'
  },
  {
    label: '标的物',
    required: true,
    type: 'input',
    name: 'subjectMatterName',
    maxLength
  },
  // {
  //   label: '制造商',
  //   required: false,
  //   type: 'input',
  //   name: 'subjectMatterBrand',
  //   maxLength
  // },
  {
    label: '标的物品牌',
    required: false,
    type: 'select',
    name: 'subjectMatterBrandKey',
    optionsListKey: 'subjectMatterBrand'
  },
  {
    label: ' ',
    required: false,
    type: 'input',
    name: 'subjectMatterBrand',
    placeholder: '填写制造商',
    maxLength
  },
  {
    label: '标的物型号',
    required: false,
    type: 'input',
    name: 'subjectMatterModel',
    maxLength
  },
  {
    label: '项目是否要求国产',
    required: false,
    type: 'checkbox',
    name: 'importType',
    optionsListKey: 'importType',
    className: 'client_import_type'
  },
  {
    label: '标的物中标单价(万元)',
    required: false,
    type: 'amount',
    disabled: true,
    name: 'subjectMatterPrice',
    maxLength: amountMaxLength,
    max: amountMax
  },
  {
    label: '台数',
    required: false,
    type: 'step',
    name: 'subjectMatterNumber',
    max: 1000,
    min: 1
  },
  {
    label: '标的物中标总价(万元)',
    required: false,
    type: 'amount',
    name: 'totalAmount',
    maxLength: amountMaxLength,
    max: amountMax
  },
  // {
  //   label: '预计采购时间',
  //   required: false,
  //   type: 'time',
  //   name: 'estimatedPurchaseTime'
  // },
  {
    label: '中标商',
    required: false,
    type: 'input',
    name: 'successfulCompany',
    maxLength
  }
  // {
  //   label: '中标金额(如未填写，请备注说明)',
  //   required: false,
  //   type: 'amount',
  //   name: 'successfulPrice',
  //   maxLength: amountMaxLength,
  //   max: amountMax
  // },
  // {
  //   label: '中标金额备注',
  //   required: false,
  //   type: 'input',
  //   name: 'successfulPriceRemark',
  //   maxLength
  // },
  // {
  //   label: '主要配置',
  //   required: false,
  //   type: 'input',
  //   name: 'majorDispositions',
  //   maxLength
  // }
];

export const use_ALL_ANNOUNCEMENTS_COLUMNS = () => {
  const sectorMark = useSectorMark();

  return [
    {
      title: '公告类型',
      dataIndex: 'noticeTypeValue',
      key: 'noticeTypeValue'
    },
    {
      title: 'AI预识别产品线',
      dataIndex: 'productLineAiList',
      key: 'productLineAiList',
      width: 130,
      render: (val: string[], record: any) => {
        // 直销直接显示-- 经销按下列逻辑显示
        if (record.dataFlag === DataFlagEnum.directSelling) {
          return '--';
        }
        const values = val?.map((x: string) => x).join(',');
        return (
          <div className="class-ai">
            <span>{values || ''}</span>
          </div>
        );
      }
    },
    {
      title: 'AI预识别',
      dataIndex: 'classTypeValueAiList',
      key: 'classTypeValueAiList',
      render: (val: string[], record: any) => {
        // 直销直接显示-- 经销按下列逻辑显示
        if (record.dataFlag === DataFlagEnum.directSelling) {
          return '--';
        }
        const values = val?.map((x: string) => x).join(',');
        const aiFlag = record.aiFlag;
        const starImg = (
          <img className="star-icon" src={BlueStarIcon} alt="star" />
        );
        if (aiFlag) {
          if (values) {
            return (
              <div className="class-ai">
                {val?.map((value: string, index: number) => (
                  <span key={`${value}-${index}`}>
                    {index > 0 && ','}
                    {value === 'A' && starImg}
                    {value}
                  </span>
                ))}
              </div>
            );
          } else {
            return (
              <div className="class-ai no-class-ai">
                {StatusAiTextEnum.manual}
              </div>
            );
          }
        } else {
          return (
            <div className="class-ai no-class-ai">
              {StatusAiTextEnum.manual}
            </div>
          );
        }
      }
    },
    {
      title: '公告范围',
      dataIndex: 'dataFlag',
      key: 'dataFlag',
      render: (val: any) => {
        return val === DataFlagEnum.dealer ? '经销' : '直销';
      }
    },
    {
      title: '当前处理人',
      dataIndex: 'currentProcessorUserName',
      key: 'currentProcessorUserName',
      width: 120
    },
    {
      title: '信息标题',
      dataIndex: 'infoTitle',
      key: 'infoTitle',
      width: 200
    },
    {
      title: '项目名称',
      dataIndex: 'noticeName',
      key: 'noticeName',
      width: 200
    },
    {
      title: sectorMark,
      dataIndex: 'sectorTypeValue',
      key: 'sectorTypeValue'
    },
    {
      title: '客户单位',
      dataIndex: 'customerCompany',
      key: 'customerCompany',
      width: 200
    },
    {
      title: '客户单位类型',
      dataIndex: 'customerCompanyTypeName',
      key: 'customerCompanyTypeName',
      width: 150,
      render: (val: any, record: any) => {
        return record.customerCompanyTypeName
          ? `${record.customerCompanyTypeName}${
              record.customerCompanySecondTypeName ? '/' : ''
            } ${record.customerCompanySecondTypeName || ''}`
          : '';
      }
    },
    {
      title: '行业',
      dataIndex: 'industryName',
      key: 'industryName',
      width: 100
    },
    {
      title: '应用方向',
      dataIndex: 'applicationDirectionName',
      key: 'applicationDirectionName',
      width: 120,
      render: (val: any, record: any) => {
        const { applicationDirectionName, applicationDirectionSecondName } =
          record;
        return `${applicationDirectionName ? applicationDirectionName : ''}${
          applicationDirectionSecondName
            ? '/' + applicationDirectionSecondName
            : ''
        }`;
      }
    },
    {
      title: '产品分类',
      dataIndex: 'productLineName',
      key: 'productLineName',
      width: 100
    },
    {
      title: '标的物',
      dataIndex: 'subjectMatterName',
      key: 'subjectMatterName',
      width: 120
    },
    {
      title: '项目是否要求国产',
      dataIndex: 'importTypeValue',
      key: 'importTypeValue',
      width: 150
    },
    {
      // 公告标的物总数量
      title: '台数',
      dataIndex: 'subjectMatterTotalNumber',
      key: 'subjectMatterTotalNumber'
    },
    {
      title: '招标预算（万元）',
      dataIndex: 'tenderBudget',
      key: 'tenderBudget',
      width: 100,
      render: (val: any) => {
        return numFormat(val);
      }
    },
    {
      title: '省',
      dataIndex: 'provinceName',
      key: 'provinceName'
    },
    {
      title: '市',
      dataIndex: 'cityName',
      key: 'cityName'
    },
    // {
    //   title: '中标金额',
    //   dataIndex: 'successfulPrice',
    //   key: 'successfulPrice'
    // },
    {
      title: '中标商',
      dataIndex: 'successfulCompany',
      key: 'successfulCompany',
      width: 120
    },
    {
      title: '标的物品牌',
      dataIndex: 'subjectMatterBrand',
      key: 'subjectMatterBrand',
      width: 120
    },
    {
      title: '客户单位联系人',
      dataIndex: 'tenderOrgContacts',
      key: 'tenderOrgContacts',
      width: 120
    },
    {
      title: '客户单位联系方式',
      dataIndex: 'tenderOrgContactsMobile',
      key: 'tenderOrgContactsMobile',
      width: 150
    },
    {
      title: '发布时间',
      dataIndex: 'publishTime',
      key: 'publishTime',
      width: 120
    },
    {
      title: '最近修改时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 120
    },
    // {
    //   title: '预计采购时间',
    //   dataIndex: 'estimatedPurchaseTime',
    //   key: 'estimatedPurchaseTime'
    // },
    {
      title: '开标时间',
      dataIndex: 'tenderOpenTime',
      key: 'tenderOpenTime',
      width: 120
    }
  ] as ColumnsType;
};

export enum ANNOUNCEMENT_COLLAPSE_TYPE {
  NOTICE = 'NOTICE',
  TARGET_STUFF = 'TARGET_STUFF'
}

//公告状态:1:待admin处理(软状态,数据初始化默认状态,只有admin分配sector后,sector才能看到),2：待Sector处理,3：待销售确认,4：完成确认,5：不相关,6:重复,9:关联项目,7:创建项目,8:更新字段
export enum NOTICE_STATUS {
  Admin = '',
  Sector = 2,
  Sales = 3,
  Confirmed = 4,
  Uncorrelated = 5,
  Repetition = 6,
  Related = 9,
  Created = 7,
  Updated = 8,
  ToBeTendered = 10, // 待招标
  Tendering = 11, // 招标中
  EndTender = 12, // 结束招标
  Abandoned = 13, // 废标/流标
  ToBeDealerConfirm = 15, // 待经销商确认
  ToBeOppId = 31 // 待补充OppId
}

/**
 * 2:转Sector
 * 3:转销售
 * 4:完成确认
 * 5:标记不相关
 * 6:标记重复
 * 7:创建项目
 * 8:更新字段
 * 9:删除项目
 * 10:关联项目
 * 55:标的物标记不相关
 * 66:标的物标记重复
 * 12:撤回公告
 * 13:撤回标的物
 * 14:撤回项目
 */
export enum TIMELINE_STATUS {
  Admin = '',
  Sector = 2,
  Sales = 3,
  Uncorrelated = 5,
  Confirmed = 4,
  Repetition = 6,
  Delete = 9,
  Created = 7,
  Updated = 8,
  Relation = 10,
  SubjectMatterUncorrelated = 55,
  SubjectMatterRepetition = 66,
  revertAnnouncement = 12,
  revertSubjectMatter = 13,
  revertProject = 14,
  transferToDealer = 15
}

// 1:全部创建项目,2:部分创建项目,3:未创建项目
export enum CONFIRM_RESULT_STATUS_MAP {
  ALL = 1,
  PART = 2,
  NOT = 3
}

export const tagClassMap: any = {
  [NOTICE_STATUS.Admin]: '',
  [NOTICE_STATUS.Sector]: 'tag_2',
  [NOTICE_STATUS.Sales]: 'tag_3',
  [NOTICE_STATUS.Confirmed]: 'tag_4',
  [NOTICE_STATUS.Uncorrelated]: 'tag_5',
  [NOTICE_STATUS.Repetition]: 'tag_6'
};

export const comfirmTagClassMap: any = {
  [CONFIRM_RESULT_STATUS_MAP.ALL]: 'tag_4',
  [CONFIRM_RESULT_STATUS_MAP.PART]: 'tag_3',
  [CONFIRM_RESULT_STATUS_MAP.NOT]: 'tag_2'
};

export enum DataFlagEnum {
  directSelling = 0,
  dealer = 1
}

export const announcementTabStatusMap = {
  TobeHandledByAdmin: '1', // 待Admin处理
  TobeHandledBySector: '2', // 待Sector处理
  TobeConfirmedBySales: '3', // 待销售确认
  TobeConfirmedByDealer: '15', // 待经销商确认
  Confirmed: '4', // 已完成确认
  Uncorrelated: '5', // 已标记不相关
  Repetition: '6' // 已标记重复
};

export enum StatusAiTextEnum {
  succeeded = 'AI计算成功',
  failed = 'AI判断失败，需人工判断',
  partial = '需要人工复核',
  running = 'AI计算中',
  manual = '人工判断'
}

export enum StatusAiEnum {
  SUCCEEDED = 'succeeded', // 'AI计算成功',
  FAILED = 'failed', // 'AI判断失败，需人工判断',
  PARTIAL = 'partial', // '需要人工复核',
  RUNNING = 'running' // 'AI计算中',
}
